export interface IterableInAppRequest {
    email ?: string;
    userId ?: string;
    count : number;
    platform : PlatformName;
    SDKVersion ?: string;
    packageName ?: string;
  }
  
  export interface IterableOpenMsgInAppRequest {
      email ?: string;
      messageId : string;
  }

  export interface IterableClickMsgInAppRequest {
      email ?: string;
      messageId : string;
      clickedUrl : string;
  }

  export enum PlatformName {
    IOS = "iOS",
    ANDROID = "Android"
  } 


// WEBPACK FOOTER //
// ./src/model/api/iterables/iterables-inapp-request.entity.interface.ts